import axiosInstance from "../../config/axiosInstance";

const dashboardOperationRequest = async () => {
    return await axiosInstance.dillApi().get("operations/dashboard/");
};

export default dashboardOperationRequest;
